import * as React from 'react';

import YesNoRadioButtons, {
  YesNoRadioButtonsProps,
} from './yesNoRadioButtons';
import InputErrorMessage from './inputErrorMessage';

interface ErrorableYesNoRadioButtonsProps extends YesNoRadioButtonsProps {
  showError: boolean;
  errorMessage: string;
}

export default class ErrorableYesNoRadioButtons extends React.PureComponent<ErrorableYesNoRadioButtonsProps, {}> {
  render(): JSX.Element {
    return (
      <YesNoRadioButtons
        question={this.props.question}
        name={this.props.name}
        isYesChecked={this.props.isYesChecked}
        isNoChecked={this.props.isNoChecked}
        onChange={this.props.onChange}
      >
        <InputErrorMessage
          showError={this.props.showError}
          message={this.props.errorMessage}
        />
      </YesNoRadioButtons>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/errorableYesNoRadioButtons.tsx